document.addEventListener("DOMContentLoaded", function(){

document.querySelectorAll(".mobile-product-carousel").forEach(function(carousel){

let track = carousel.querySelector(".mobile-product-carousel-track");

let slides = carousel.querySelectorAll(".mobile-product-slide");

let index = 0;


if(slides.length < 2) return;


setInterval(function(){

index++;

if(index >= slides.length){
index = 0;
}


track.style.transform =
"translateX(-" + (index * 100) + "%)";


},3000);


});

});